import { makeStyles } from "@material-ui/core/styles";
import { CloseOutlined, SearchOutlined } from "@material-ui/icons";
// import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import Edit from "@material-ui/icons/Edit";
import PaymentIcon from '@material-ui/icons/Payment';
// import PersonAddIcon from "@material-ui/icons/PersonAdd";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { Tooltip } from "@mui/material";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CustomAlert from "components/CustomAlert/CustomAlert";
import Button from "components/CustomButtons/Button.js";
import CustomDataGrid from "components/CustomDataGrid.js/CustomDataGrid";
import CustomInput from "components/CustomInput/CustomInput";
import CustomModal from "components/CustomModal/CustomModal";
import CustomSelect from "components/CustomSelect/CustomSelect";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem";
import { LoginContext } from "contexts/LoginContext";
import useUpdateUser from "hooks/userHooks/useUpdateUser";
import React, { useContext, useEffect, useState } from "react";
import GetAllEnquiries from "services/EnquiryService/GetAllEnquiries";
import AddPaymentModal from "views/Forms/AddPaymentModal";
import EnquiryConvertModal from "views/Forms/EnquiryConvertModal";
import AddEnquiry from "views/Forms/EnquiryForm";

const useStyles = makeStyles(styles);

export default function UserEnquiryListing(props) {

    var enableSearch = false;
    let Status;
    let mobile;
    let email;
    let name;
    const updateUser = useUpdateUser();

    const [columns, setColumns] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [addEnquiryForm, setAddEnquiryForm] = React.useState(null);
    const [paymentModal, setPaymentModal] = React.useState(null);
    const [convertModal, setConvertModal] = React.useState(null);
    const [bulkOption, setBulkOption] = React.useState({});
    const [bulkOptions, setBulkOptions] = useState([]);
    const [bulkValue, setBulkValue] = React.useState("");

    const [userEditForm, setUserEditForm] = React.useState(null);
    const [deleteModal, setDeleteModal] = React.useState(null);
    const [licensingMessage, setLicensingMessage] = React.useState(false);
    const [enquiryPageState, setEnquiryPageState] = React.useState({
        isLoading: false,
        data: [],
        total: 0,
        page: 1,
        pageSize: 10,
    });

    const statusOptions = [
        { id: "New", name: "New" },
        { id: "Contacted", name: "Contacted" },
        { id: "Interested", name: "Interested" },
        { id: "Converted", name: "Converted" },
        { id: "Dropped", name: "Dropped" },
    ];
    const { user, licensePackageObject, userPrivileges } = useContext(LoginContext);
    const fetchData = async (pageNumber, pageSize, Status, name, mobile, email) => {
        setEnquiryPageState((old) => ({ ...old, isLoading: true }));

        let getEnquiries = await GetAllEnquiries.getAllEnquiries(
            pageNumber,
            pageSize,
            Status,
            name,
            mobile,
            email
        );
        console.log(getEnquiries, "getEnquiries");
        setEnquiryPageState((old) => ({
            ...old,
            isLoading: false,
            data: getEnquiries?.list?.$values,
            total: getEnquiries?.total ?? 0,
        }));
    };

    useEffect(() => {
        setBulkOptions([
            {
                id: 0,
                name: "Select",
                inputType: "text",
                key: "select",
                // updateMethod: updateTests,
                component: getCustomSelect([
                    {
                        id: 0,
                        name: "Select",
                    },
                ]),
            },
            {
                id: 1,
                name: "Name",
                inputType: "text",
                key: "name",
                component: getCustomInput("text"),
            },
            {
                id: 2,
                name: "Email",
                inputType: "text",
                key: "email",
                component: getCustomInput("email"),
            },
            {
                id: 3,
                name: "Mobile",
                inputType: "text",
                key: "mobile",
                component: getCustomInput("text"),
            },

            {
                id: 4,
                name: "Status",
                inputType: "text",
                key: "status",
                component: getCustomSelect(statusOptions),
            },

        ]);
    }, []);
    const handleBulkOptionFieldChange = (v) => {
        // setBulkValue("");
        console.log(
            v,
            "gettingvals",
            bulkOptions.find((x) => x.id == v)
        );
        setBulkOption(bulkOptions.find((x) => x.id == v));
    };

    const handleInputChange = (e) => {
        setBulkValue(e.target.value);
    };

    const isPrivilege = (x) => {
        if (userPrivileges?.Privileges?.Enquiry.indexOf(x) !== -1) {
            return true;
        }
        else {
            return false;
        }
    }
    const getCustomInput = (type) => {
        return (
            <CustomInput
                formControlProps={{
                    fullWidth: true,
                }}
                inputProps={{
                    fullWidth: true,
                    onBlur: handleInputChange,
                    type: type,
                    autoComplete: "off",
                }}
            />
        );
    };

    const getCustomSelect = (options) => {
        if (options.length <= 0) return;
        return (
            <CustomSelect
                options={options.map((x) => ({ id: x.id, name: x.name }))}
                setvalue={(v) => {
                    handleInputChange({ target: { value: v } });
                }}
            />
        );
    };

    const handleSearch = () => {
        console.log("searchClicked");
        enableSearch = false;
        filterValues(1, 10);
    };

    const handleClear = () => {
        console.log("clearClicked");

        setBulkValue("");
        setBulkOption({});
        enableSearch = true;

        filterValues(1, 10);
    };



    const filterValues = (pageNumber, pageSize) => {
        if (enableSearch == false) {
            if (bulkOption.name == "Status") {
                Status = bulkValue;
            }
            if (bulkOption.name == "Name") {
                name = bulkValue;
            }
            if (bulkOption.name == "Email") {
                email = bulkValue;
            }
            if (bulkOption.name == "Mobile") {
                mobile = bulkValue;
            }
        } else {
            Status = null;
            name = null;
            mobile = null;
            email = null;
        }
        fetchData(
            pageNumber,
            pageSize,
            Status,
            name,
            mobile,
            email
        );
    };
    React.useEffect(() => {
        if (enquiryPageState.page > 0) {
            fetchData(enquiryPageState.page, enquiryPageState.pageSize);
        }
    }, [enquiryPageState.page, enquiryPageState.pageSize, addEnquiryForm]);
    const classes = useStyles();

    const onUpdate = (e, values) => {
        e.preventDefault();

        updateUser.mutate(values.row);
    };

    const handleRowSelection = (e) => {
        setSelection(e);
    };

    const onCellEditCommit = (p) => { };

    const onCellBlur = (e, p) => { };

    const handleEdit = (p, e) => { };
    console.log("users", enquiryPageState);
    console.log("rows", rows);
    React.useEffect(() => {
        if (enquiryPageState?.data) {
            setRows(
                enquiryPageState?.data?.map((e) => ({
                    id: e.enquiryId,
                    enquiryid: e.enquiryId,
                    name: e.name,
                    email: e.email,
                    mobile: e.mobile,
                    status: e.status,
                    programId: e.programId,
                    source: e.source,
                    paidAmount: e.totalPaid,
                    convertedUserId: e?.convertedUserId,
                    remainingAmount: e.remainingAmount,
                    canConvert: e.totalPaid > 0,
                })),
            );
        }
    }, [enquiryPageState?.data]);

    React.useEffect(() => {
        let cols = [
            {
                field: "enquiryid",
                headerName: "#",
                width: 90,
                hide: true,
            },
            {
                field: "name",
                headerName: "Name",
                editable: false,
                width: 250,
            },
            {
                field: "email",
                headerName: "Email",
                editable: false,
                width: 250,
            },
            {
                field: "mobile",
                headerName: "Mobile",
                editable: false,
                width: 150,
            },
            {
                field: "status",
                headerName: "Status",
                editable: false,
                width: 150,
            },
            {
                field: "actions",
                headerName: "Actions",
                editable: false,
                width: 300,
                filterable: false,
                sortable: false,
                renderCell: (cellValues) => {
                    const row = cellValues.row;

                    return (
                        <>
                            {isPrivilege("UpdateEnquiry") == true ? (
                                <Tooltip title="Edit Enquiry">
                                    <Button
                                        size="sm"
                                        justIcon
                                        round
                                        className={classes.actionButton}
                                        style={{ backgroundColor: "#DD4B39" }}
                                        onClick={() => handleCreateEnquiry(row)}
                                        disabled={row.status === "Converted" || row.status === "Dropped"}
                                    >
                                        <Edit />
                                    </Button>
                                </Tooltip>
                            ) : null}
                            {/* Add Payment */}
                            {
                                <Tooltip title="Add Payment">
                                    <Button
                                        size="sm"
                                        justIcon
                                        round
                                        className={classes.actionButton}
                                        style={{ backgroundColor: "#4CAF50" }}
                                        onClick={() => openPaymentModal(row)}
                                        disabled={row.status !== "Converted"}
                                    >
                                        {/* 💰 */}
                                        <PaymentIcon />
                                    </Button>
                                </Tooltip>
                            }

                            {/* Convert */}
                            {
                                <Tooltip title="Confirm Admission">
                                    <Button
                                        size="sm"
                                        justIcon
                                        round
                                        className={classes.actionButton}
                                        style={{ backgroundColor: "#2196F3" }}
                                        onClick={() => handleConvertModal(row)}
                                        disabled={row.status === "Converted" || row.status === "Dropped"}
                                    >
                                        <VerifiedUserIcon />
                                    </Button>
                                </Tooltip>
                            }
                        </>
                    );
                },
            },
        ];

        setColumns(cols);
    }, []);

    const handleCreateEnquiry = async (user) => {
        setAddEnquiryForm(
            <CustomModal
                modal={true}
                setModal={() => hideAddEnquirynFormModal()}
                content={
                    <AddEnquiry
                        isEdit={user ? true : false}
                        initialData={user ?? null}
                        afterFinish={() => hideAddEnquirynFormModal()}
                    // refetch={handleRefetch}
                    />
                }
                cancelButtonMessage="cancel"
                okButtonMessage="Create"
                showOk={false}
                onCancelClick={() => hideAddEnquirynFormModal()}
                title={"Enquiry Form"}
                maxWidth="lg"
                fullWidth={true}
            />,
        );
    };
    const hideAddEnquirynFormModal = () => {
        setAddEnquiryForm(null);
    };

    const hideUserEditForm = () => {
        setUserEditForm(null);
    };

    const openPaymentModal = (row) => {
        setPaymentModal(
            <CustomModal
                modal={true}
                setModal={() => setPaymentModal(null)}
                content={
                    <AddPaymentModal
                        enquiry={row}
                        onClose={() => setPaymentModal(null)}
                        onSuccess={() => fetchData(enquiryPageState.page, enquiryPageState.pageSize)}
                    />
                }
                title="Payment"
                maxWidth="md"
                fullWidth
                showOk={false}
            />
        );
    };

    const handleConvertModal = (row) => {
        setConvertModal(
            <CustomModal
                modal={true}
                setModal={() => {
                    setConvertModal(null);
                    fetchData(enquiryPageState.page, enquiryPageState.pageSize)
                }}
                content={
                    <EnquiryConvertModal
                        enquiry={row}
                        onClose={() => setConvertModal(null)}
                        afterConvert={() => fetchData(enquiryPageState.page, enquiryPageState.pageSize)}
                    />
                }
                title="Finalize Student Admission"
                maxWidth="md"
                fullWidth
                showOk={false}
            />
        );
    };
    const getRowClassName = (row) => {
        return null;
    };

    return (
        <Card>
            <CardHeader color="rose" icon>
                <CardIcon color="rose">
                    <SupervisorAccountIcon />
                </CardIcon>
            </CardHeader>
            <CardBody>
                <GridContainer
                    style={{ marginBottom: 21 }}
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    spacing={2}
                >
                    <GridItem xs={12} sm={12} md={2}>
                        <CustomSelect
                            label="Select field"
                            options={bulkOptions}
                            setvalue={handleBulkOptionFieldChange}
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                        {bulkOption && bulkOption.component ? (
                            bulkOption.component
                        ) : (
                            <CustomInput
                                id="filename"
                                formControlProps={{
                                    fullWidth: true,
                                }}
                                inputProps={{
                                    fullWidth: true,
                                    onChange: handleInputChange,
                                    type: "text",
                                    value: bulkValue,
                                    autoComplete: "off",
                                }}
                            />
                        )}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                        <Button
                            color="primary"
                            onClick={handleClear}
                            style={{
                                marginTop: 20,
                                marginRight: 14,
                                padding: 12,
                                textTransform: "none",
                            }}
                        // disabled={testPageState.isLoading == true}
                        >
                            <CloseOutlined style={{ marginRight: "0px" }} />
                        </Button>
                        <Button
                            color="primary"
                            onClick={handleSearch}
                            style={{
                                marginTop: 20,
                                marginRight: 14,
                                padding: 12,
                                textTransform: "none",
                            }}
                        >
                            <SearchOutlined style={{ marginRight: "0px" }} />
                        </Button>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        {isPrivilege("CreateEnquiry") == true ? (
                            <Button
                                color="primary"
                                onClick={() => {
                                    // if (rows?.length + 1 > licensePackageObject?.ApplicationUsers) {
                                    //     setLicensingMessage(true);
                                    //     setTimeout(() => {
                                    //         setLicensingMessage(false);
                                    //     }, 2000);
                                    //     return;
                                    // } else {
                                    handleCreateEnquiry();
                                    // }
                                    //getQ();
                                }}
                                style={{ marginTop: 20, marginRight: 20, textTransform: "none", float: 'right' }}
                            >
                                + Add
                            </Button>
                        ) : null}
                    </GridItem>


                </GridContainer>

                <div style={{ height: 650, width: "100%" }}>
                    <div style={{ display: "flex", height: "100%" }}>
                        {enquiryPageState.isLoading == false && enquiryPageState.data ? (
                            <div style={{ flexGrow: 1 }}>
                                {isPrivilege("ViewEnquiry") == true ? (
                                    <CustomDataGrid
                                        columns={columns}
                                        rows={rows}
                                        rowCount={enquiryPageState?.total}
                                        loading={enquiryPageState.isLoading}
                                        paginationMode="server"
                                        onPageChange={(newPage) => setEnquiryPageState(old => ({ ...old, page: newPage + 1 }))}
                                        onPageSizeChange={(newPageSize) => setEnquiryPageState(old => ({ ...old, pageSize: newPageSize }))}
                                        page={enquiryPageState.page - 1}
                                        pageSize={enquiryPageState.pageSize}
                                        rowsPerPageOptions={[10, 30, 50, 70, 100]}
                                        onEditCellPropsChange={handleEdit}
                                        onCellEditCommit={onCellEditCommit}
                                        onSelectionModelChange={handleRowSelection}
                                        getRowClassName={getRowClassName}
                                        onCellBlur={onCellBlur}
                                    />
                                ) : ""}
                            </div>
                        ) : (
                            <CustomDataGrid
                                rows={[]}
                                loading={enquiryPageState.isLoading}
                                columns={columns}
                                // checkboxSelection
                                getRowClassName={getRowClassName}
                            />
                        )}
                    </div>
                </div>
            </CardBody>
            {updateUser.isError == true && (
                <CustomAlert
                    open={true}
                    severity="error"
                    alertMessage="Error while updating user"
                />
            )}
            {updateUser.isSuccess == true && (
                <CustomAlert
                    open={true}
                    severity="success"
                    alertMessage="User Updated successfully"
                />
            )}
            {licensingMessage == true && (
                <CustomAlert
                    open={true}
                    severity="warning"
                    alertMessage="Please upgrade to higher package to create additional users."
                />
            )}
            {addEnquiryForm}
            {convertModal}
            {paymentModal}
            {userEditForm}
            {deleteModal}
        </Card>
    );
}
